// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ────────────────────────────────────────────────────────────────────────────
   RacksFrontView — vista «Frontal» del listado de Racks
   Armarios lado a lado con los equipos en su U y sus cables. Paleta del tema.
   ──────────────────────────────────────────────────────────────────────────── */

.rfv {
  --rfv-patch: #2563eb;
  --rfv-fiber: #8b5cf6;
  --rfv-wall: #16a34a;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  padding: 0.75rem 1rem 1rem;
  box-sizing: border-box;
}

.rfv-head {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  font-size: 0.72rem;
  color: var(--text-muted);
}
.rfv-legend {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.rfv-line {
  display: inline-block;
  width: 22px;
  height: 0;
  border-top: 2px solid var(--rfv-patch);
}
.rfv-line.is-fiber {
  border-top: 2px dashed var(--rfv-fiber);
}
.rfv-line.is-wall {
  border-top: 2px dotted var(--rfv-wall);
}
.rfv-count {
  margin-left: auto;
  font-weight: 600;
  color: var(--text-secondary, var(--text-muted));
}

.rfv-scroll {
  overflow: auto;
  max-width: 100%;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--bg-surface, var(--bg-card));
  padding: 4px;
}

.rfv-svg {
  display: block;
}

/* Armario */
.rfv-frame {
  fill: color-mix(in srgb, var(--bg-card) 94%, #3b82f6 6%);
  stroke: var(--slate-300, #cbd5e1);
  stroke-width: 2;
  cursor: pointer;
  transition: stroke 0.12s;
}
.rfv-frame:hover { stroke: var(--primary, #3b82f6); }
.rfv-title {
  font-size: 12px;
  font-weight: 700;
  fill: var(--text-primary);
  pointer-events: none;
}
.rfv-slot {
  stroke: var(--border);
  stroke-width: 1;
  stroke-dasharray: 2 3;
  opacity: 0.5;
}
.rfv-u {
  font-size: 7px;
  fill: var(--text-muted);
}

/* Equipo montado */
.rfv-unit-rect {
  fill: var(--bg-surface, #fff);
  stroke: var(--kind, #94a3b8);
  stroke-width: 1.4;
}
.rfv-unit-bar { fill: var(--kind, #94a3b8); }
.rfv-unit-name {
  font-size: 9px;
  font-weight: 700;
  fill: var(--text-primary);
}
.rfv-unit-u {
  font-size: 7px;
  font-weight: 600;
  fill: var(--text-muted);
}

/* Puertos */
.rfv-port rect {
  fill: var(--bg-surface, #fff);
  stroke: var(--text-muted);
  stroke-width: 1;
}
.rfv-port.is-busy rect {
  fill: var(--rfv-patch);
  stroke: var(--rfv-patch);
}

/* Cables */
.rfv-cable {
  fill: none;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
  opacity: 0.9;
}
.rfv-cable.is-backbone {
  stroke: var(--rfv-fiber);
  stroke-dasharray: 7 4;
  stroke-width: 2.2;
}
.rfv-cable.is-wall_run {
  stroke: var(--rfv-wall);
  stroke-dasharray: 2 4;
}

/* Estados */
.rfv-state {
  padding: 2.5rem 1rem;
  text-align: center;
  color: var(--text-muted);
  font-size: 0.85rem;
}
.rfv-state.is-error { color: var(--danger, #dc2626); }
.rfv-state-ic { font-size: 2rem; margin-bottom: 6px; }
.rfv-state-sub {
  margin-top: 6px;
  font-size: 0.76rem;
  opacity: 0.8;
}
`, "",{"version":3,"sources":["webpack://./src/components/RacksFrontView.css"],"names":[],"mappings":"AAAA;;;iFAGiF;;AAEjF;EACE,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,SAAS;EACT,sCAAsC;AACxC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,6CAA6C;EAC7C,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,wDAAwD;EACxD,iCAAiC;EACjC,eAAe;EACf,eAAe;EACf,wBAAwB;AAC1B;AACA,mBAAmB,+BAA+B,EAAE;AACpD;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,iBAAiB;AACnB;AACA,gBAAgB,0BAA0B,EAAE;AAC5C;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,YAAY;AACZ;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA,WAAW;AACX;EACE,UAAU;EACV,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;AACA,sBAAsB,6BAA6B,EAAE;AACrD,gBAAgB,eAAe,EAAE,kBAAkB,EAAE;AACrD;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd","sourcesContent":["/* ────────────────────────────────────────────────────────────────────────────\r\n   RacksFrontView — vista «Frontal» del listado de Racks\r\n   Armarios lado a lado con los equipos en su U y sus cables. Paleta del tema.\r\n   ──────────────────────────────────────────────────────────────────────────── */\r\n\r\n.rfv {\r\n  --rfv-patch: #2563eb;\r\n  --rfv-fiber: #8b5cf6;\r\n  --rfv-wall: #16a34a;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n  width: 100%;\r\n  max-width: 100%;\r\n  min-width: 0;\r\n  padding: 0.75rem 1rem 1rem;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.rfv-head {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 14px;\r\n  flex-wrap: wrap;\r\n  font-size: 0.72rem;\r\n  color: var(--text-muted);\r\n}\r\n.rfv-legend {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n.rfv-line {\r\n  display: inline-block;\r\n  width: 22px;\r\n  height: 0;\r\n  border-top: 2px solid var(--rfv-patch);\r\n}\r\n.rfv-line.is-fiber {\r\n  border-top: 2px dashed var(--rfv-fiber);\r\n}\r\n.rfv-line.is-wall {\r\n  border-top: 2px dotted var(--rfv-wall);\r\n}\r\n.rfv-count {\r\n  margin-left: auto;\r\n  font-weight: 600;\r\n  color: var(--text-secondary, var(--text-muted));\r\n}\r\n\r\n.rfv-scroll {\r\n  overflow: auto;\r\n  max-width: 100%;\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  background: var(--bg-surface, var(--bg-card));\r\n  padding: 4px;\r\n}\r\n\r\n.rfv-svg {\r\n  display: block;\r\n}\r\n\r\n/* Armario */\r\n.rfv-frame {\r\n  fill: color-mix(in srgb, var(--bg-card) 94%, #3b82f6 6%);\r\n  stroke: var(--slate-300, #cbd5e1);\r\n  stroke-width: 2;\r\n  cursor: pointer;\r\n  transition: stroke 0.12s;\r\n}\r\n.rfv-frame:hover { stroke: var(--primary, #3b82f6); }\r\n.rfv-title {\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  fill: var(--text-primary);\r\n  pointer-events: none;\r\n}\r\n.rfv-slot {\r\n  stroke: var(--border);\r\n  stroke-width: 1;\r\n  stroke-dasharray: 2 3;\r\n  opacity: 0.5;\r\n}\r\n.rfv-u {\r\n  font-size: 7px;\r\n  fill: var(--text-muted);\r\n}\r\n\r\n/* Equipo montado */\r\n.rfv-unit-rect {\r\n  fill: var(--bg-surface, #fff);\r\n  stroke: var(--kind, #94a3b8);\r\n  stroke-width: 1.4;\r\n}\r\n.rfv-unit-bar { fill: var(--kind, #94a3b8); }\r\n.rfv-unit-name {\r\n  font-size: 9px;\r\n  font-weight: 700;\r\n  fill: var(--text-primary);\r\n}\r\n.rfv-unit-u {\r\n  font-size: 7px;\r\n  font-weight: 600;\r\n  fill: var(--text-muted);\r\n}\r\n\r\n/* Puertos */\r\n.rfv-port rect {\r\n  fill: var(--bg-surface, #fff);\r\n  stroke: var(--text-muted);\r\n  stroke-width: 1;\r\n}\r\n.rfv-port.is-busy rect {\r\n  fill: var(--rfv-patch);\r\n  stroke: var(--rfv-patch);\r\n}\r\n\r\n/* Cables */\r\n.rfv-cable {\r\n  fill: none;\r\n  stroke-width: 1.8;\r\n  stroke-linecap: round;\r\n  stroke-linejoin: round;\r\n  opacity: 0.9;\r\n}\r\n.rfv-cable.is-backbone {\r\n  stroke: var(--rfv-fiber);\r\n  stroke-dasharray: 7 4;\r\n  stroke-width: 2.2;\r\n}\r\n.rfv-cable.is-wall_run {\r\n  stroke: var(--rfv-wall);\r\n  stroke-dasharray: 2 4;\r\n}\r\n\r\n/* Estados */\r\n.rfv-state {\r\n  padding: 2.5rem 1rem;\r\n  text-align: center;\r\n  color: var(--text-muted);\r\n  font-size: 0.85rem;\r\n}\r\n.rfv-state.is-error { color: var(--danger, #dc2626); }\r\n.rfv-state-ic { font-size: 2rem; margin-bottom: 6px; }\r\n.rfv-state-sub {\r\n  margin-top: 6px;\r\n  font-size: 0.76rem;\r\n  opacity: 0.8;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
